import { useEffect, useState } from 'react';
import styles from './Gratuit.module.css';
import { EventModel } from '../models/EventModel';
import { Helmet } from 'react-helmet-async';
import SubscriptionSection from '../components/SubscriptionSection';
import EventItem from '../components/EventItem';
import { Link } from 'react-router-dom';

export default function Gratuit() {

    const preloaded = (window as any).__FREE_EVENTS__ ?? {};
    console.log(preloaded);
    const [eventsToday, setEventsToday] = useState<EventModel[]>(preloaded.today || []);
    const [eventsThisWeek, setEventsThisWeek] = useState<EventModel[]>(preloaded.thisWeek || []);

    useEffect(() => {
        setEventsToday(preloaded.today || []);
        setEventsThisWeek(preloaded.thisWeek || []);
    }, preloaded);

    const title = `Activités gratuites à Québec – Événements et sorties gratuites aujourd’hui et cette semaine`;
    const description = `Découvrez toutes les activités gratuites à Québec : spectacles, expositions, festivals et événements gratuits aujourd’hui et cette semaine. Mis à jour en continu.`;

    return <div style={{position: 'relative'}}>
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={location.href} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
        </Helmet>
        <SubscriptionSection stickyBanner={true}/>
        <h1>Activités gratuites à Québec</h1>
        <p>Vous cherchez des activités gratuites à Québec ?
        Sur alentours, découvrez tous les événements gratuits à Québec : concerts, expositions, activités culturelles, festivals et sorties à faire gratuitement aujourd’hui ou cette semaine. Cette page est mise à jour en continu pour vous proposer uniquement des activités réellement gratuites, partout dans la ville de Québec.</p>

        <h2>Activités gratuites à Québec aujourd’hui</h2>
        <div className={styles.eventsContainer}>
            {eventsToday.length == 0 && <div>
                <p>Il n'y a aucune activité gratuite aujourd'hui. </p>
                </div>}
            {eventsToday.map(e => 
                <EventItem event={e} />
            )}
        </div>
        <div style={{display:"flex", justifyContent: "center", gap: "20px", flexDirection: "column"}}>
            <Link to="/ville-quebec/aujourdhui" reloadDocument><button type="button" className={styles.searchBtn}>Voir tous les événements aujourd'hui</button></Link>
        </div>

        <h2>Activités gratuites à Québec cette semaine</h2>
        <div className={styles.eventsContainer}>
            {eventsThisWeek.length == 0 && <div>
                <p>Il n'y a aucune activité gratuite cette semaine. </p>
                </div>}
            {eventsThisWeek.map(e => 
                <EventItem event={e} />
            )}
        </div>

        <h2>Certaines activités sont gratuites grâce au soutien de la Ville de Québec, d’organismes culturels ou d’initiatives citoyennes. Tout au long de l’année, de nombreux lieux proposent des événements accessibles à tous sans frais.</h2>

        <div style={{display:"flex", justifyContent: "center", gap: "20px", flexDirection: "column"}}>
            <Link to="/ville-quebec/evenements-cette-semaine" reloadDocument><button type="button" className={styles.searchBtn}>Voir tous les événements de cette semaine</button></Link>
            <Link to="/#search"><button type="button" className={styles.searchBtn}>Rechercher parmis tous les événements</button></Link>
        </div>
        <SubscriptionSection />
    </div>;

}